import "./ClusterCard.css";
import ConfigManager from "../../utils/ConfigManager.js";

class ClusterCard {
  constructor(cluster) {
    this.cluster = cluster;
    this.isExpanded = false;
  }

  render() {
    const { cluster } = this;

    return `
      <div class="cluster-card">
        <div class="cluster-header">
          <div class="cluster-info">
            <div class="cluster-meta">
              <span class="cluster-pbo">${cluster.pbo}</span>
              <span class="cluster-lambda">λ ${cluster.lambda}nm</span>
            </div>
          </div>
        </div>
        
        <div class="cluster-content expanded">
          <div class="fibers-table-container">
            ${this.renderFibersTable()}
          </div>
        </div>
      </div>
    `;
  }

  renderFibersTable() {
    const { fibers } = this.cluster;
    const eventCount = fibers[0].attenuations.length;

    // Calculer moyenne par événement pour les attenuations
    const averages = [];
    for (let evtIndex = 0; evtIndex < eventCount; evtIndex++) {
      const sum = fibers.reduce((acc, fiber) => acc + fiber.attenuations[evtIndex], 0);
      averages.push(sum / fibers.length);
    }

    // Calculer moyennes pour les 3 colonnes agrégées
    const avgMoyConn = fibers.reduce((sum, f) => sum + f.moyenneConnecteurs, 0) / fibers.length;
    const avgMoyEpis = fibers.reduce((sum, f) => sum + f.moyenneEpissures, 0) / fibers.length;
    const avgPerteTot = fibers.reduce((sum, f) => sum + f.perteTotale, 0) / fibers.length;

    // Headers avec moyennes
    let headers = "<th>ID Câble</th><th>N° Fibre</th>";

    // Colonnes événements
    /*
    for (let evtNum = 1; evtNum <= eventCount; evtNum++) {
      const avg = averages[evtNum - 1].toFixed(3);
      headers += `<th>Att ${evtNum} (${avg})</th>`;
    }*/

    // Colonnes moyennes agrégées
    headers += `<th>Moy Conn (${avgMoyConn.toFixed(3)})</th>`;
    headers += `<th>Moy Epis (${avgMoyEpis.toFixed(3)})</th>`;
    headers += `<th>Perte Tot (${avgPerteTot.toFixed(3)})</th>`;

    return `
    <table class="fibers-table">
      <thead>
        <tr>${headers}</tr>
      </thead>
      <tbody>
        ${fibers.map((fiber) => this.renderFiberRow(fiber, averages, avgMoyConn, avgMoyEpis, avgPerteTot)).join("")}
      </tbody>
    </table>
  `;
  }

  renderFiberRow(fiber, averages, avgMoyConn, avgMoyEpis, avgPerteTot) {
    // Récupérer la config pour les seuils
    const config = ConfigManager.getConfig();

    // Identifier l'autre fibre dans la paire
    const otherFiber = this.cluster.fibers.find((f) => f !== fiber);

    // Calculer les différences ENTRE LES 2 FIBRES (pas avec la moyenne)
    const diffConn = Math.abs(fiber.moyenneConnecteurs - otherFiber.moyenneConnecteurs);
    const diffEpis = Math.abs(fiber.moyenneEpissures - otherFiber.moyenneEpissures);
    const diffPerte = Math.abs(fiber.perteTotale - otherFiber.perteTotale);

    // Déterminer si sous le seuil
    const connMatch = diffConn <= config.seuilMoyenneConnecteurs;
    const episMatch = diffEpis <= config.seuilMoyenneEpissures;
    const perteMatch = diffPerte <= config.seuilPerteTotale;

    const formatValue = (value) => {
      if (value === null || value === undefined) return "-";
      return typeof value === "number" ? value.toFixed(3) : value;
    };

    const formatDeviation = (value, avg) => {
      const deviation = value - avg;
      const sign = deviation >= 0 ? "+" : "";
      return `${sign}${deviation.toFixed(3)}`;
    };

    // Cellules événements avec valeur et écart à la moyenne
    /*
    const attenuationCells = fiber.attenuations
      .map((value, index) => {
        const deviation = value - averages[index];
        const deviationText = formatDeviation(value, averages[index]);
        const deviationClass = deviation >= 0 ? "deviation-positive" : "deviation-negative";
        return `<td class="fiber-event">${formatValue(value)} <sub class="deviation-value ${deviationClass}">(${deviationText})</sub></td>`;
      })
      .join("");*/

    // Cellules moyennes agrégées
    const moyConnDeviation = formatDeviation(fiber.moyenneConnecteurs, avgMoyConn);
    const moyConnClass = fiber.moyenneConnecteurs - avgMoyConn >= 0 ? "deviation-positive" : "deviation-negative";

    const moyEpisDeviation = formatDeviation(fiber.moyenneEpissures, avgMoyEpis);
    const moyEpisClass = fiber.moyenneEpissures - avgMoyEpis >= 0 ? "deviation-positive" : "deviation-negative";

    const perteTotDeviation = formatDeviation(fiber.perteTotale, avgPerteTot);
    const perteTotClass = fiber.perteTotale - avgPerteTot >= 0 ? "deviation-positive" : "deviation-negative";

    const moyConnCell = `<td class="fiber-event ${connMatch ? "threshold-exceed" : "threshold-match"}">${formatValue(fiber.moyenneConnecteurs)} <sub class="deviation-value ${moyConnClass}">(${moyConnDeviation})</sub></td>`;
    const moyEpisCell = `<td class="fiber-event ${episMatch ? "threshold-exceed" : "threshold-match"}">${formatValue(fiber.moyenneEpissures)} <sub class="deviation-value ${moyEpisClass}">(${moyEpisDeviation})</sub></td>`;
    const perteTotCell = `<td class="fiber-event ${perteMatch ? "threshold-exceed" : "threshold-match"}">${formatValue(fiber.perteTotale)} <sub class="deviation-value ${perteTotClass}">(${perteTotDeviation})</sub></td>`;

    /*      ${attenuationCells}*/
    return `
    <tr class="fiber-row">
      <td class="fiber-id">${fiber.idCable}</td>
      <td class="fiber-num">${fiber.numFibre}</td>
      ${moyConnCell}
      ${moyEpisCell}
      ${perteTotCell}
    </tr>
  `;
  }

  mount(container) {
    container.innerHTML = this.render();
  }

  bindEvents(container) {
    const toggleBtn = container.querySelector(".btn-toggle");
    const content = container.querySelector(".cluster-content");
    const toggleIcon = container.querySelector(".toggle-icon");

    if (toggleBtn) {
      toggleBtn.addEventListener("click", () => {
        this.isExpanded = !this.isExpanded;

        if (this.isExpanded) {
          content.classList.remove("collapsed");
          content.classList.add("expanded");
          toggleIcon.style.transform = "rotate(180deg)";
        } else {
          content.classList.remove("expanded");
          content.classList.add("collapsed");
          toggleIcon.style.transform = "rotate(0deg)";
        }
      });
    }
  }
}

export default ClusterCard;
